<template>
  <div class="content-wrap">
    <el-form :inline="true">
      <!-- <el-form-item label="考核时间"  width="340px">
        <el-date-picker
          v-model="queryDate"
          type="daterange"
          range-separator="~"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期" style="width: 260px;">
        </el-date-picker>
      </el-form-item> -->

      <!--<el-form-item label="考核场景">
        <el-select v-model="searchData.sceneId" placeholder="请选择">
          <el-option v-for="(item, key) in majorList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>-->
      <!-- <el-form-item label="淘金客">
        <tjkautocompleteall @callBack="updateTjkId" :tjkId="searchData.tjkId"></tjkautocompleteall>
      </el-form-item> -->
      <!-- <el-form-item label="考核讲师">
        <tjkautocompleteall @callBack="updateTeacherTjkId" :teacherTjkId="searchData.teacherTjkId"></tjkautocompleteall>
      </el-form-item> -->
      <!-- <el-form-item label="是否合格">
        <el-select v-model="searchData.sceneExamPass" clearable placeholder="请选择" style="width: 150px;">
          <el-option label="是" value="Yes"></el-option>
          <el-option label="否" value="No"></el-option>
          <el-option label="未打分" value="Empty"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="getList">查询</el-button>
        <!-- <el-button type="primary" @click="exportList">导出</el-button> -->
        <el-button type="primary" @click="gobackScene">返回</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border highlight-current-row style="width: 100%">
      <el-table-column prop="beginTime" label="考核时间" align="center" width="180"></el-table-column>
      <el-table-column prop="courseName" label="课程名称" align="center"></el-table-column>
      <el-table-column prop="realName" label="客服" align="center" width="162">
        <template slot-scope="scope">
          {{ scope.row.realName }}（{{ scope.row.tjkNumber }}）
        </template>
      </el-table-column>
      <el-table-column prop="teacherName" label="讲师" align="center" width="162">
        <template slot-scope="scope">
          {{ scope.row.teacherName }}（{{ scope.row.teacherTjkNumber }}）
        </template>
      </el-table-column>
      <el-table-column label="考核结果" align="center">
        <el-table-column prop="baseScore" label="基本条件" align="center"></el-table-column>
        <el-table-column prop="skillScore" label="服务技巧" align="center"></el-table-column>
        <el-table-column prop="riteScore" label="服务礼仪" align="center"></el-table-column>
        <el-table-column prop="flowScore" label="服务流程" align="center"></el-table-column>
      </el-table-column>
      <el-table-column prop="gradeScore" label="分数" align="center"></el-table-column>
      <el-table-column label="是否合格" align="center">
        <template slot-scope='scope'>
          <span v-if="scope.row.sceneExamPass=='Yes'">是</span>
          <span v-if="scope.row.sceneExamPass=='No'">否</span>
          <span v-if="scope.row.sceneExamPass=='Empty'"></span>
        </template>
      </el-table-column>
      <!--<el-table-column label="操作" align="center">
        <template slot-scope='scope'>
          <a class="link-text" :href="'/studyManage/voiceScene/recordDetailExam?id='+scope.row.id" target="_blank">详情</a>
        </template>
      </el-table-column>-->
    </el-table>
    <pagination :pages="searchData.pages" :pageNum="searchData.pageNum" @getData="getList"></pagination>
  </div>
</template>

<script>
  import pagination from '@/components/pagination'
  export default {
    components: { pagination },
    data () {
      return {
        businessMajorId: this.$route.query.businessMajorId, //场景id
        searchData: {
          courseId:this.$route.query.courseId,
          pageNum:1,
          pageSize:10,
          pages:0,
          tjkId: this.$route.query.tjkId,
          trainId: this.$route.query.trainId,
          teacherTjkId: this.$route.query.teacherTjkId,
          sceneId: '',
          effectStatus: this.$route.query.effectStatus,
          callInterVal: this.$route.query.callInterVal,
          qcEffectStatus: this.$route.query.qcEffectStatus,
          goodStatus: null,
          qcStatus: null,
          callInterval: this.$route.query.callInterVal
        },
        queryDate: null,
        majorList: [],
        list:[]
      }
    },
    mounted: function () {
      // this.querySceneList();
      this.getList();
    },
    methods: {
      //查询场景
      querySceneList() {
        this.$http.post(API_ROOT.college + '/voiceScene/listExamSceneActive').then(response => {
          var result = response.data
          if(result.success) {
          this.majorList = result.data
        }else {
          this.$alert(result.msg)
        }
      }, response => {
          this.$alert('网络繁忙，请稍后重试！')
        })
      },
      updateTjkId(val) {
        this.searchData.tjkId = val.id;
      },
      updateTeacherTjkId(val) {
        this.searchData.teacherTjkId = val.id;
      },
      //点分页组件的数字/下一页，会回传pageNum过来，平时直接点查新，参数是event对象，所以需要isNAN判断
      getList(pageNum) {
        if(this.queryDate){
          this.searchData.beginTime = this.queryDate[0];
          this.searchData.endTime   = this.queryDate[1];
        }
        if(pageNum && isNaN(pageNum) == false){
            this.searchData.pageNum = pageNum;
        }
        this.$http.post(API_ROOT.college + '/voiceExerciseRecord/queryTjkExamRecordAll', this.searchData).then(response=> {
          var result = response.data;
        if(result.success) {
          this.searchData.pageSize = result.data.pageSize;
          this.searchData.pages = result.data.pages;

          this.list = result.data.list;
        }else {
          this.$alert(result.msg);
        }
      },response=> {
          this.$alert("网络繁忙，请稍后重试！");
        })
      },
      exportList() {
        window.open(API_ROOT.college + '/export/excel/exportVoiceExamRecordList?' + this.urlEncode(this.searchData));
      },
      gobackScene() {
          // this.$router.push({path: '/train/courseList', query: {id: this.businessMajorId, type: 'SkillUpgrade', show:'no'}});
          this.$router.go(-1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ./src/page/train/record/examRecordList.vue